import React, { lazy } from "react";
import {
  Route,
  Switch,
  useLocation
} from "react-router-dom";
import { connect } from 'react-redux';
import LeftSidebar from '../../components/left_side_bar';
import { motion } from "framer-motion";
import AuthCheck from '../../routes/auth_check';
import Menu from './menu';
import { ROUTES_PATH_CONFIG } from '../../config/routes';

const CompanyDashboard = lazy(() => import('./dashboard'));
const CompanyProfile = lazy(() => import('./profile'));
const CompanyUsers = lazy(() => import('./users'));
const Contractors = lazy(() => import('./users/work/contractors'));
const WorkPosts = lazy(() => import('./users/work/posts'));
const Rfq = lazy(() => import('./users/work/rfq'));
const MeetingSchedules = lazy(() => import('./users/work/meeting_schedules'));
const CompanySubscription = lazy(() => import('./subscription'));

function CompanyRoute(props) {
  const location = useLocation();
  const {
    authData
  } = props;


  const user = authData.user ?
    authData.user : { role: "none" };

  return (<Route
    {...props}
    render={() => <AuthCheck>
      <LeftSidebar menuContent={Menu[user.role]}>
        <Switch location={location} key={location.pathname}>
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit="in"
            transition={{ duration: 1 }}>
            <Route
              path={ROUTES_PATH_CONFIG.COMPANY.dashboard}
              component={CompanyDashboard}
            />

            <Route
              path={ROUTES_PATH_CONFIG.COMPANY.profile}
              component={CompanyProfile}
            />

            <Route
              path={ROUTES_PATH_CONFIG.COMPANY.users}
              component={CompanyUsers}
            />

            <Route
              path={ROUTES_PATH_CONFIG.COMPANY.contractors}
              component={Contractors}
            />

            <Route
              path={ROUTES_PATH_CONFIG.COMPANY.work_posts}
              component={WorkPosts}
            />

            <Route
              path={ROUTES_PATH_CONFIG.COMPANY.rfq}
              component={Rfq}
            />

            <Route
              path={ROUTES_PATH_CONFIG.COMPANY.meeting_schedules}
              component={MeetingSchedules}
            />

            <Route
              path={ROUTES_PATH_CONFIG.COMPANY.subscription}
              component={CompanySubscription}
            />

          </motion.div>
        </Switch>
      </LeftSidebar>
    </AuthCheck>
    }
  />
  );
}

CompanyRoute.defaultProps = {
  authData: {}
}

const mapStateToProps = state => ({
  authData: state.AUTH
});

export default connect(mapStateToProps)(CompanyRoute);